module.exports = __webpack_public_path__ + "media/images/youtube_social_squircle_red-f76fa08512e9bf26ad1522faf2527fd5.png";